// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"109":"d15c70f9","378":"320dd6f8","453":"dfe5a820","660":"1ffed895","914":"3ce15773"}[chunkId] + ".chunk.js";
};